'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextInput = function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput(props) {
    _classCallCheck(this, TextInput);

    var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));

    _this.state = { hasDeviated: false };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(TextInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var recommendedValue = _ref.recommendedValue;
      var hasDeviated = this.state.hasDeviated;
      var _props = this.props,
          id = _props.id,
          onChange = _props.onChange,
          oldValue = _props.recommendedValue;

      // Use recommended while not deviated.

      if (!hasDeviated && recommendedValue && recommendedValue !== oldValue) {
        onChange(id, recommendedValue);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(_ref2) {
      var _ref2$target = _ref2.target,
          id = _ref2$target.id,
          value = _ref2$target.value;
      var onChange = this.props.onChange;

      if (value !== this.props.value) {
        this.setState({ hasDeviated: true });
      }
      onChange(id, value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          value = _props2.value,
          placeholder = _props2.placeholder,
          fieldSuffix = _props2.fieldSuffix,
          valid = _props2.valid,
          onBlur = _props2.onBlur;

      var validClass = valid ? '' : 'invalid';
      return _react2.default.createElement(
        'div',
        { className: 'text-input' },
        _react2.default.createElement('input', {
          id: id,
          value: value,
          placeholder: placeholder,
          className: validClass,
          onChange: this.handleChange,
          onBlur: onBlur,
          onKeyPress: function onKeyPress(event) {
            // Blur the input when enter is pressed.
            if (event.charCode === 13) {
              event.target.blur();
            }
          },
          type: 'text'
        }),
        fieldSuffix !== '' ? _react2.default.createElement(
          'span',
          { className: 'field-suffix' },
          fieldSuffix
        ) : null
      );
    }
  }]);

  return TextInput;
}(_react.Component);

TextInput.defaultProps = {
  value: '',
  placeholder: '',
  fieldSuffix: '',
  valid: true,
  recommendedValue: ''
};


TextInput.propTypes = {
  id: _propTypes2.default.string.isRequired,
  placeholder: _propTypes2.default.string,
  fieldSuffix: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  valid: _propTypes2.default.bool,
  recommendedValue: _propTypes2.default.string
};

TextInput.displayName = 'TextInput';

exports.default = TextInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/form/elements/TextInput.js
// module id = 459
// module chunks = 0